/**
 * Identity GraphQL Mutations — Re-exports from codegen
 *
 * Source: types/identity.graphql.ts (generated from api/gql/identity.front.graphql)
 * Client: identity-client.ts (targets federation gateway directly)
 *
 * These mutations route through the federation gateway:
 *   Client → API Gateway → Auth Service (Apollo Federation)
 */
export {
    // Document Nodes
    InitiateIdentityOtpChallengeDocument,
    VerifyIdentityOtpChallengeDocument,
    IdentitySignUpDocument,
    // Generated Hooks
    useInitiateIdentityOtpChallengeMutation,
    useVerifyIdentityOtpChallengeMutation,
    useIdentitySignUpMutation,
    // Operation Types
    type InitiateIdentityOtpChallengeMutation,
    type InitiateIdentityOtpChallengeMutationVariables,
    type VerifyIdentityOtpChallengeMutation,
    type VerifyIdentityOtpChallengeMutationVariables,
    type IdentitySignUpMutation,
    type IdentitySignUpMutationVariables,
    // Schema Types
    type IdentityOtpChallengeResponse,
    type IdentityAuthResult,
    type IdentitySignUpResult,
} from '../../types/identity.graphql';
